"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPAND_COLUMN = void 0;
var EXPAND_COLUMN = {};
exports.EXPAND_COLUMN = EXPAND_COLUMN;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/lib/constant.js
// module id = 454
// module chunks = 1